import axios from "axios";
import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import styled from "styled-components";

export default function ErrorFallback({ error, resetErrorBoundary }) {
  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.errorPage,
  }));
  useEffect(() => {
    if (error) {
      axios.post("/error/notification", error.stack.toString());
    }
  }, [error]);

  return (
    <Container>
      <p>{lang[0]}...</p>
      <Button
        variant="outline-secondary"
        className="mt-2"
        onClick={resetErrorBoundary}
      >
        {lang[1]}
      </Button>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
